import React from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIconUrl from 'leaflet/dist/images/marker-icon.png';
import markerIconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import markerShadowUrl from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIconRetinaUrl,
  iconUrl: markerIconUrl,
  shadowUrl: markerShadowUrl,
});

// Draggable pin on an OpenStreetMap tile layer — no API key needed (Feature 1.2)
const DeliveryMap = ({ lat, lng, onChange }) => {
  const position = [lat, lng];
  return (
    <div className="rounded-xl overflow-hidden border border-[#ECE0DA]" data-testid="delivery-map">
      <MapContainer
        key={`${lat.toFixed(5)}-${lng.toFixed(5)}`}
        center={position}
        zoom={14}
        style={{ height: '220px', width: '100%' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker
          draggable
          position={position}
          eventHandlers={{
            dragend: (e) => {
              const p = e.target.getLatLng();
              onChange(p.lat, p.lng);
            },
          }}
        />
      </MapContainer>
      <p className="text-[10px] text-[#7A6A63] text-center py-1 bg-[#FDF8F3]">Drag the pin to fine-tune your exact delivery spot</p>
    </div>
  );
};

export default DeliveryMap;
